import React, { useRef, useState } from "react";
import { Button, ButtonToolbar, Form, Modal, Schema, Loader } from "rsuite";
import { StringType } from "schema-typed";
import { UserServices } from "../../../core/services/UserServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useNavigate } from "react-router-dom";
import {
  httpStatusArr,
  messageTypeArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";

const ChangePassword = (props: any): any => {
  const { t } = useTranslation();
  const fromRef = useRef<any>();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [patternError, setPatternError] = useState("");
  const [formData, setFormData] = useState<any>({});
  const changePasswordModel = Schema.Model({
    oldPassword: StringType()
      .isRequired(
        t("REQUIRED", {
          field: t("OLD_PASSWORD").toLowerCase(),
        })
      )
      .addRule((value: string, data: any): any => {
        setPatternError("");
        if (
          //review comment:save this string to a constant file to reuse it TP
          value.match(
            /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/
          ) === null
        ) {
          setPatternError(t("PASSWORD_PATTERN"));
        } else {
          setPatternError("");
        }
      }),
    newPassword: StringType()
      .isRequired(
        t("REQUIRED", {
          field: t("NEW_PASSWORD").toLowerCase(),
        })
      )
      .addRule((value: string, data: any): any => {
        setPatternError("");
        if (
          //review comment:save this string to a constant file to reuse it TP
          value.match(
            /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/
          ) === null
        ) {
          setPatternError(t("PASSWORD_PATTERN"));
        } else {
          setPatternError("");
        }
      }),
    confirmNewPassword: StringType().isRequired(
      t("REQUIRED", {
        field: t("CONFIRM_PASSWORD").toLowerCase(),
      })
    ),
  });

  async function handleUpdatePassword(data: any) {
    try {
      setLoader(true);
      const res = await UserServices.updatePassword(data);
      if (
        res &&
        res.data &&
        res.data.message &&
        res?.data?.status === httpStatusArr.ok
      ) {
        setLoader(false);
        UtilityServices.showToaster({
          message: res.data.message,
        });
        navigate(-1);
      }
    } catch (error: any) {
      if (error && error.message) {
        setLoader(false);
        UtilityServices.showToaster({
          message: error?.message,
          type: messageTypeArr.error,
        });
      }
    }
  }
  const updatePassword = (form: any): any => {
    if (form === true) {
      console.log(formData);
      let payload = {
        old_password: formData.oldPassword,
        password: formData.newPassword,
        confirm_password: formData.confirmNewPassword,
      };
      handleUpdatePassword(payload);
    } else {
      if (
        form &&
        form.newPassword &&
        form.confirmNewPassword &&
        form["newPassword"] === form["confirmNewPassword"]
      ) {
        setPatternError("");
      } else if (
        form &&
        form.newPassword &&
        form.confirmNewPassword &&
        form["newPassword"] !== form["confirmNewPassword"]
      ) {
        setPatternError(
          t("DOES_NOT_MATCH", {
            field1: t("NEW") + " " + t("PASSWORD").toLowerCase(),
            field2: t("CONFIRM") + " " + t("PASSWORD").toLowerCase(),
          })
        );
      }
    }
  };

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          backdrop
          content={t("LOADING")}
          vertical
        />
      )}
      <Modal
        open={true}
        backdrop="static"
        onClose={(e: any) => {
          setPatternError("");
          setFormData({});
          navigate(-1);
        }}
      >
        <Modal.Header className="mb-3">
          <Modal.Title>
            <b>
              {t("UPDATE")} {t("PASSWORD")}
            </b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            ref={fromRef}
            fluid
            model={changePasswordModel}
            className="content"
            onSubmit={updatePassword}
            onChange={(data: any) => {
              if (data) {
                setFormData(data);
                updatePassword(data);
              }
            }}
          >
            <Form.Group controlId="oldPassword">
              <Form.ControlLabel>{t("OLD_PASSWORD")}</Form.ControlLabel>
              <Form.Control name="oldPassword" type="password" />
            </Form.Group>
            <Form.Group controlId="newPassword">
              <Form.ControlLabel>{t("NEW_PASSWORD")}</Form.ControlLabel>
              <Form.Control name="newPassword" type="password" />
            </Form.Group>
            <Form.Group controlId="confirmNewPassword">
              <Form.ControlLabel>
                {t("CONFIRM")} {t("NEW_PASSWORD")}
              </Form.ControlLabel>
              <Form.Control
                name="confirmNewPassword"
                type="password"
                autoComplete="off"
              />
            </Form.Group>
            {!!patternError && (
              <Form.Group>
                <Form.HelpText style={{ color: "red" }}>
                  {patternError}
                </Form.HelpText>
              </Form.Group>
            )}
            <ButtonToolbar
              className="text-center"
              style={{ width: "100%", justifyContent: "center" }}
            >
              <Button
                appearance="primary"
                type="submit"
                disabled={!!patternError}
              >
                {t("UPDATE")}
              </Button>
              <Button
                onClick={(e: any) => {
                  navigate(-1);
                  setPatternError("");
                  setFormData({});
                }}
                color="red"
                appearance="primary"
              >
                {t("CANCEL")}
              </Button>
            </ButtonToolbar>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ChangePassword;
